import React from "react";
import PropTypes from "prop-types";
import { Badge } from "@opendate-app/setlist";

const CATEGORY_COLORS = ["pink", "gray-blue", "orange", "purple", "indigo", "purple", "gray-blue"];

export function categoryColor(category) {
  const text = String(category || "");
  let hash = 0;
  for (let i = 0; i < text.length; i += 1) hash = (hash * 31 + text.charCodeAt(i)) % 1000003;
  return CATEGORY_COLORS[hash % CATEGORY_COLORS.length];
}

export default function ClassCategoryBadge({ category, size = "sm" }) {
  if (!category) return null;
  return <Badge color={categoryColor(category)} size={size} dot>{category}</Badge>;
}

ClassCategoryBadge.propTypes = {
  category: PropTypes.string,
  size: PropTypes.oneOf(["sm", "md", "lg"]),
};
